// extracted by mini-css-extract-plugin
var _1 = "BtZXYviEp21S1KegKxmb";
var _2 = "YAhLdt7709DqlCrNQj9v";
var _3 = "B3kjr5I2HNATn74qJ8w6";
var _4 = "MopA3ityXk7rF49FvR6O";
var _5 = "Zvy8qwTH5FkzHJoHHW03";
export { _1 as "empty", _2 as "giftsHeader", _3 as "grid", _4 as "imgL", _5 as "root" }
